<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=568 content-class="round-2xl")
  v-card
    v-card-title.pa-0
    div.px-6.pt-2
      .text-lg.font-medium.mt-6 {{ $t('delete_confirmation', { text: $t('printer').toLowerCase() }) }}
      v-card.round-md.pa-4.mt-4(v-if="selectedPrinter" outlined color="neutral300")
        .text-md.font-semibold {{ selectedPrinter.name }}
        .text-sm.mt-1 {{ $t('hostname') }} : {{ selectedPrinter.host.hostname }}
      .text-md.mt-4 {{ $t('delete_confirmation_desc', { text: $t('printer').toLowerCase() }) }}
      .text-md.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.px-0(text @click="closeDialog") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="isLoading" color="danger500" depressed dark @click="onConfirm") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    selectedPrinter: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
    async onConfirm () {
      try {
        this.isLoading = true
        await this.$axios.delete(`/iot/${this.company.slug}/printers/${this.selectedPrinter.id}`)
        this.$emit('deleted')
        this.showMessage(['success', this.$t('success_message.delete_successful')])
        this.closeDialog()
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
    }
  }
}
</script>